import { Button } from "@/components/ui/button"
import { ArrowLeft, Home } from "lucide-react"
import { Link } from "react-router-dom"
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleBack = () => {
        if (location.key !== 'default') {
            navigate(-1); // Go back if there's a previous page
        } else {
            navigate('/'); // Otherwise go to home
        }
    };
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 text-center">
      <div className="space-y-6 max-w-md">
        <h1 className="text-9xl font-extrabold tracking-tight text-primary">404</h1>
        <h2 className="text-3xl font-bold tracking-tight">Page Not Found</h2>
        <p className="text-muted-foreground">
          Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or never
          existed.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-6">
          <Button asChild variant="default">
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
          <Button variant="outline" onClick={handleBack}>
            {/* <Link to="/"> */}
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            {/* </Link> */}
          </Button>
        </div>
      </div>
    </div>
  )
}